/**
 * KraftCover Custom Search Component
 * - Capture phase click interception to prevent Focal drawer
 * - Shopify Predictive Search API integration
 * - Mobile: full-width overlay bar
 * - Desktop: inline search with dropdown
 */

(function () {
  'use strict';

  /* ========== CONFIG ========== */
  var DEBOUNCE_MS = 250;
  var MIN_QUERY_LENGTH = 2;
  var MAX_PRODUCTS = 6;
  var MAX_COLLECTIONS = 3;
  var PLACEHOLDER_INTERVAL_MS = 3000;

  /* ========== STATE ========== */
  var searchController = null;
  var debounceTimer = null;
  var scrollPos = 0;

  /* ========== HELPERS ========== */

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(price) {
    // Shopify Predictive Search API returns price as a string like "2800.00"
    // It is already in the main currency unit (TL), NOT in cents
    if (typeof price === 'number') price = price.toString();
    if (!price) return '';
    // Remove trailing .00 for cleaner display
    var clean = price.replace(/\.00$/, '').replace(/\.(\d)0$/, '.$1');
    // Replace dot with comma for Turkish format
    clean = clean.replace('.', ',');
    return clean + ' TL';
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    // Shopify image URL resize pattern
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|avif)(\?.*)?$/i);
    if (match) {
      var prefix = url.substring(0, match.index);
      var suffix = match[0];
      return prefix + '_' + size + suffix;
    }
    return url;
  }

  function debounce(fn, delay) {
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  /**
   * Türkçe karakterleri ASCII'ye dönüştür.
   * Kullanıcı 'sirt' yazsa da 'sırt' yazsa da aynı sonuçlar gelsin.
   */
  function normalizeTurkish(str) {
    if (!str) return '';
    return str
      .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/ı/g, 'i')
      .replace(/Ğ/g, 'g').replace(/ğ/g, 'g')
      .replace(/Ç/g, 'c').replace(/ç/g, 'c')
      .replace(/Ş/g, 's').replace(/ş/g, 's')
      .replace(/Ö/g, 'o').replace(/ö/g, 'o')
      .replace(/Ü/g, 'u').replace(/ü/g, 'u')
      .toLowerCase();
  }

  /**
   * İki sonuç dizisini birleştir, id'ye göre dedupe et.
   */
  /**
   * Clear button'u input'ta text varsa göster, yoksa gizle.
   */
  function toggleClearButton(input, clearBtn) {
    if (!input || !clearBtn) return;
    if (input.value.length > 0) {
      clearBtn.classList.add('is-visible');
    } else {
      clearBtn.classList.remove('is-visible');
    }
  }

  function mergeResults(arr1, arr2) {
    var seen = {};
    var merged = [];
    function pushUnique(items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var key = item.id || item.url || item.handle || item.title;
        if (!seen[key]) {
          seen[key] = true;
          merged.push(item);
        }
      }
    }
    pushUnique(arr1 || []);
    pushUnique(arr2 || []);
    return merged;
  }

  /* ========== CLICK INTERCEPTION ========== */
  /* Capture phase: fires BEFORE Focal's toggle-link custom element */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[aria-controls="search-drawer"]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (window.innerWidth <= 740) {
      openMobileSearch();
    } else {
      focusDesktopSearch();
    }
  }, true); // true = capture phase

  /* ========== MOBILE SEARCH ========== */

  function openMobileSearch() {
    var el = document.getElementById('kc-search-mobile');
    if (!el) return;

    scrollPos = window.pageYOffset;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kc-search-open');
    document.body.style.top = -scrollPos + 'px';

    requestAnimationFrame(function () {
      var input = el.querySelector('.kc-search-mobile__input');
      if (input) input.focus();
    });
  }

  function closeMobileSearch() {
    var el = document.getElementById('kc-search-mobile');
    if (!el) return;

    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kc-search-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollPos);

    var input = el.querySelector('.kc-search-mobile__input');
    if (input) {
      input.value = '';
      input.blur();
    }

    var results = el.querySelector('.kc-search-mobile__results');
    if (results) results.innerHTML = '';
  }

  /* ========== DESKTOP SEARCH ========== */

  function focusDesktopSearch() {
    var input = document.querySelector('.kc-search-desktop__input');
    if (input) input.focus();
  }

  function closeDesktopDropdown() {
    var dropdown = document.querySelector('.kc-search-desktop__dropdown');
    if (dropdown) dropdown.classList.remove('is-open');
  }

  /**
   * Dropdown'un konumunu search bar'ın altında hizala.
   * position: fixed olduğu için search bar hareket ettiğinde (scroll, resize) güncellemek gerekiyor.
   * Bu yaklaşım dropdown'ı header'ın stacking context'inden çıkarıp üstte tutmayı sağlıyor.
   */
  function positionDesktopDropdown() {
    var form = document.querySelector('.kc-search-desktop__form');
    var dropdown = document.querySelector('.kc-search-desktop__dropdown');
    if (!form || !dropdown) return;
    var rect = form.getBoundingClientRect();
    var dropdownWidth = Math.max(rect.width, 420);
    // Ekrana sığdır
    var maxLeft = window.innerWidth - dropdownWidth - 16;
    var left = Math.min(rect.left, maxLeft);
    left = Math.max(16, left);
    dropdown.style.top = (rect.bottom + 6) + 'px';
    dropdown.style.left = left + 'px';
    dropdown.style.width = dropdownWidth + 'px';
  }

  /* ========== PREDICTIVE SEARCH API ========== */

  /**
   * Tek bir API çağrısı yap - ürün + koleksiyon + sayfa.
   */
  function fetchSuggest(query, signal) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=' + MAX_PRODUCTS +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body,tag';
    return fetch(url, { signal: signal }).then(function (r) { return r.json(); });
  }


  function performSearch(query, resultsContainer, isMobile) {
    if (query.length < MIN_QUERY_LENGTH) {
      resultsContainer.innerHTML = '';
      if (!isMobile) resultsContainer.classList.remove('is-open');
      return;
    }

    // Show loading
    resultsContainer.innerHTML = '<div class="kc-search-loading"><span class="kc-search-loading__spinner"></span></div>';
    if (!isMobile) {
      resultsContainer.classList.add('is-open');
      positionDesktopDropdown();
    }

    // Abort previous request
    if (searchController) {
      try { searchController.abort(); } catch (e) { /* ignore */ }
    }
    searchController = new AbortController();
    var signal = searchController.signal;

    // Synonym map — Shopify suggest API title-bazlı; bazı sorgular için
    // alternatifleri paralel çağır (örn "çanta" → "sling" Rove'u getirir).
    var SYNONYMS = {
      'canta': ['sling', 'backpack'],
      'çanta': ['sling', 'backpack'],
      'sirt cantasi': ['backpack'],
      'sırt çantası': ['backpack'],
      'capraz canta': ['sling'],
      'çapraz çanta': ['sling']
    };

    // Türkçe karakter toleransı: orijinal VE normalized query'yi paralel gönder
    var normalized = normalizeTurkish(query);
    var originalPromises = [fetchSuggest(query, signal)];
    if (normalized !== query.toLowerCase()) {
      originalPromises.push(fetchSuggest(normalized, signal));
    }

    // Synonym fan-out (ayrı bucket — interleave edilecek)
    var qLower = query.toLowerCase().trim();
    var syns = SYNONYMS[qLower] || SYNONYMS[normalized.trim()];
    var synonymPromises = (syns || []).map(function (s) { return fetchSuggest(s, signal); });

    Promise.all([Promise.all(originalPromises), Promise.all(synonymPromises)])
      .then(function (groups) {
        var origResponses = groups[0], synResponses = groups[1];
        var origProducts = [], synProducts = [], collections = [];

        origResponses.forEach(function (data) {
          var r = data && data.resources && data.resources.results;
          if (r) {
            origProducts = mergeResults(origProducts, r.products || []);
            collections = mergeResults(collections, r.collections || []);
          }
        });
        synResponses.forEach(function (data) {
          var r = data && data.resources && data.resources.results;
          if (r) synProducts = mergeResults(synProducts, r.products || []);
        });

        // Interleave: orig→syn→orig→syn (sırayla), MAX_PRODUCTS'a kadar
        var interleaved = [];
        var seenIds = {};
        var i = 0, j = 0;
        while (interleaved.length < MAX_PRODUCTS && (i < origProducts.length || j < synProducts.length)) {
          if (i < origProducts.length) {
            var op = origProducts[i++];
            if (op && op.id && !seenIds[op.id]) { seenIds[op.id] = true; interleaved.push(op); }
          }
          if (interleaved.length >= MAX_PRODUCTS) break;
          if (j < synProducts.length) {
            var sp = synProducts[j++];
            if (sp && sp.id && !seenIds[sp.id]) { seenIds[sp.id] = true; interleaved.push(sp); }
          }
        }

        renderResults({
          products: interleaved,
          collections: collections.slice(0, MAX_COLLECTIONS)
        }, resultsContainer, query, isMobile);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          console.error('KC Search error:', err);
          resultsContainer.innerHTML = '';
          if (!isMobile) resultsContainer.classList.remove('is-open');
        }
      });
  }

  /* ========== RENDER RESULTS ========== */

  function renderProductItem(p) {
    var imageUrl = p.image ? getSizedImageUrl(p.image, '112x112_crop_center') : '';
    var priceHtml = '';
    if (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)) {
      priceHtml =
        '<span class="kc-result-item__price--compare">' + formatMoney(p.compare_at_price_max) + '</span>' +
        '<span class="kc-result-item__price--sale">' + formatMoney(p.price) + '</span>';
    } else {
      priceHtml = formatMoney(p.price);
    }
    return '<a href="' + p.url + '" class="kc-result-item">' +
      (imageUrl ? '<img class="kc-result-item__image" src="' + imageUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
      '<div class="kc-result-item__info">' +
      '<div class="kc-result-item__title">' + escapeHtml(p.title) + '</div>' +
      '<div class="kc-result-item__price">' + priceHtml + '</div>' +
      '</div>' +
      '</a>';
  }

  function renderCollectionItem(c) {
    return '<a href="' + c.url + '" class="kc-category-item">' +
      '<svg class="kc-category-item__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M2 3h12v10H2z M5 6h6 M5 9h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>' +
      '</svg>' +
      '<span class="kc-category-item__label">' + escapeHtml(c.title) + '</span>' +
      '<span class="kc-category-item__arrow">→</span>' +
      '</a>';
  }

  function renderPageItem(p) {
    return '<a href="' + p.url + '" class="kc-category-item">' +
      '<svg class="kc-category-item__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M3 2h7l3 3v9H3z M10 2v3h3" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="kc-category-item__label">' + escapeHtml(p.title) + '</span>' +
      '<span class="kc-category-item__arrow">→</span>' +
      '</a>';
  }

  function renderResults(data, container, query, isMobile) {
    var products = data.products || [];
    var collections = data.collections || [];
    var totalResults = products.length + collections.length;

    if (totalResults === 0) {
      container.innerHTML = '<p class="kc-search-empty">"' + escapeHtml(query) + '" için sonuç bulunamadı</p>';
      if (!isMobile) {
        container.classList.add('is-open');
        positionDesktopDropdown();
      }
      return;
    }

    var html = '';

    // ÜRÜNLER (sadece — kategori listelenmez)
    if (products.length > 0) {
      html += '<div class="kc-section">' +
        '<div class="kc-section-header">Ürünler</div>' +
        products.map(renderProductItem).join('') +
        '</div>';
    }

    // "Tüm sonuçları gör" link
    html += '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="kc-search-view-all">' +
      'Tüm sonuçları gör: "' + escapeHtml(query) + '"' +
      '</a>';

    container.innerHTML = html;
    if (!isMobile) {
      container.classList.add('is-open');
      positionDesktopDropdown();
    }
  }

  /* ========== ROTATING PLACEHOLDERS ========== */

  function initRotatingPlaceholders() {
    var inputs = document.querySelectorAll('[data-placeholders]');
    inputs.forEach(function (input) {
      try {
        var placeholders = JSON.parse(input.getAttribute('data-placeholders'));
        if (!placeholders || placeholders.length === 0) return;

        var idx = 0;
        input.placeholder = placeholders[0];

        setInterval(function () {
          // Don't rotate if user is typing
          if (document.activeElement === input && input.value.length > 0) return;

          idx = (idx + 1) % placeholders.length;
          input.classList.add('placeholder-fade');

          setTimeout(function () {
            input.placeholder = placeholders[idx];
            input.classList.remove('placeholder-fade');
          }, 200);
        }, PLACEHOLDER_INTERVAL_MS);
      } catch (e) { /* ignore parse errors */ }
    });
  }

  /* ========== EVENT BINDINGS ========== */

  function init() {
    // Mobile: back button
    var mobileBack = document.querySelector('.kc-search-mobile__back');
    if (mobileBack) {
      mobileBack.addEventListener('click', closeMobileSearch);
    }

    // Mobile: overlay click
    var mobileOverlay = document.querySelector('.kc-search-mobile__overlay');
    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMobileSearch);
    }

    // Mobile: input
    var mobileInput = document.querySelector('.kc-search-mobile__input');
    var mobileResults = document.querySelector('.kc-search-mobile__results');
    var mobileClear = document.querySelector('.kc-search-mobile__clear');
    if (mobileInput && mobileResults) {
      var debouncedMobileSearch = debounce(function () {
        performSearch(mobileInput.value.trim(), mobileResults, true);
      }, DEBOUNCE_MS);

      mobileInput.addEventListener('input', function () {
        debouncedMobileSearch();
        toggleClearButton(mobileInput, mobileClear);
      });
    }
    if (mobileClear && mobileInput && mobileResults) {
      mobileClear.addEventListener('click', function () {
        mobileInput.value = '';
        mobileResults.innerHTML = '';
        toggleClearButton(mobileInput, mobileClear);
        mobileInput.focus();
      });
    }

    // Desktop: input
    var desktopInput = document.querySelector('.kc-search-desktop__input');
    var desktopDropdown = document.querySelector('.kc-search-desktop__dropdown');
    var desktopClear = document.querySelector('.kc-search-desktop__clear');
    if (desktopInput && desktopDropdown) {
      var debouncedDesktopSearch = debounce(function () {
        performSearch(desktopInput.value.trim(), desktopDropdown, false);
      }, DEBOUNCE_MS);

      desktopInput.addEventListener('input', function () {
        debouncedDesktopSearch();
        toggleClearButton(desktopInput, desktopClear);
      });

      // Focus: show dropdown if has content
      desktopInput.addEventListener('focus', function () {
        if (desktopDropdown.innerHTML.trim() && desktopInput.value.trim().length >= MIN_QUERY_LENGTH) {
          desktopDropdown.classList.add('is-open');
          positionDesktopDropdown();
        }
      });
    }
    if (desktopClear && desktopInput && desktopDropdown) {
      desktopClear.addEventListener('click', function () {
        desktopInput.value = '';
        desktopDropdown.innerHTML = '';
        desktopDropdown.classList.remove('is-open');
        toggleClearButton(desktopInput, desktopClear);
        desktopInput.focus();
      });
    }

    // Click outside desktop dropdown/search -> close (dropdown artık body'de değil ama target kontrol lazım)
    document.addEventListener('click', function (e) {
      var desktopEl = document.getElementById('kc-search-desktop');
      if (desktopEl && !desktopEl.contains(e.target)) {
        closeDesktopDropdown();
      }
    });

    // Dropdown position:fixed olduğu için resize/scroll'da pozisyonu güncelle
    window.addEventListener('resize', function () {
      var dropdown = document.querySelector('.kc-search-desktop__dropdown.is-open');
      if (dropdown) positionDesktopDropdown();
    });
    window.addEventListener('scroll', function () {
      var dropdown = document.querySelector('.kc-search-desktop__dropdown.is-open');
      if (dropdown) positionDesktopDropdown();
    }, { passive: true });

    // ESC key: close both mobile and desktop
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var mobileEl = document.getElementById('kc-search-mobile');
        if (mobileEl && mobileEl.getAttribute('aria-hidden') === 'false') {
          closeMobileSearch();
          return;
        }
        closeDesktopDropdown();
        var dInput = document.querySelector('.kc-search-desktop__input');
        if (dInput) dInput.blur();
      }
    });

    // Initialize rotating placeholders
    initRotatingPlaceholders();
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
